// extracted by mini-css-extract-plugin
export var textInput = "_jy-0";